function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Shape");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Web",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Patient-Portal-Login-//-2FA",
  transform: "translate(-140.000000, -488.000000)",
  fill: "#12253F",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M152,488.5 L142,488.5 C140.9,488.5 140,489.4 140,490.5 L140,508.5 C140,509.6 140.9,510.5 142,510.5 L152,510.5 C153.1,510.5 154,509.6 154,508.5 L154,490.5 C154,489.4 153.1,488.5 152,488.5 Z M152,507.5 L142,507.5 L142,491.5 L152,491.5 L152,507.5 Z M158.63,495.76 C158.37,495.44 157.89,495.4 157.59,495.7 L157.56,495.73 C157.31,495.98 157.3,496.38 157.51,496.66 C158.77,498.3 158.76,500.53 157.49,502.23 C157.28,502.51 157.3,502.9 157.54,503.15 L157.59,503.2 C157.88,503.49 158.35,503.46 158.62,503.15 C160.42,501.02 160.42,497.96 158.63,495.76 L158.63,495.76 Z M155.42,497.87 L155.36,497.93 C155.16,498.13 155.1,498.43 155.21,498.69 C155.42,499.18 155.42,499.72 155.21,500.21 C155.1,500.47 155.16,500.77 155.36,500.97 L155.44,501.05 C155.76,501.37 156.31,501.3 156.53,500.9 C157.02,500.01 157.02,498.96 156.52,498.04 C156.3,497.62 155.75,497.54 155.42,497.87 L155.42,497.87 Z",
  id: "Shape"
})));

var SvgMobile = function SvgMobile(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "23px",
    viewBox: "0 0 20 23",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMobile, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/mobile.10ebf873.svg";
export { ForwardRef as ReactComponent };